import { useState } from "react";
import { IconButton, Popover, Typography, Box } from "@mui/material";
// import FunctionsIcon from '@mui/icons-material/Functions';
import CalculateIcon from "@mui/icons-material/Calculate";

import { subtract,multiply } from "lodash";

const FormulaMillerTds = ({
  gst,bill_amount,tds_rate
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "formula-popover" : undefined;
 
  const calcBrokerageMiller = multiply(subtract(bill_amount ,gst,),tds_rate); 

  return (
    <>
   ₹ {Number(calcBrokerageMiller).toFixed(0)}/-
      <IconButton
        size="small"
        onClick={handleOpen}
        sx={{ padding: "0 0 0 4px" }}
      >
        <CalculateIcon fontSize="inherit" />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2}}>
          <Typography variant="body2">
            <strong>Miller Tds Formula:</strong>
            <br />
            <br /> = (Bill Amount - GST) * Tds rate %
            <br/>
            Bill Amount = {bill_amount}/-<br/>
            GST = {gst} <br/>
            Tds rate = {tds_rate}%<br/>
            <br /> = ({bill_amount} - {gst}) * {tds_rate}%
            <br />
            <strong> </strong> = ₹{Number(calcBrokerageMiller).toFixed(0)}/-
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default FormulaMillerTds;
